import React, { useState } from "react";
import UdrzbaLayout from "./udrzba/UdrzbaLayout";
import UdrzbaDashboard from "./udrzba/UdrzbaDashboard";
import UdrzbaZakazky from "./udrzba/UdrzbaZakazky";
import UdrzbaNovaZakazka from "./udrzba/UdrzbaNovaZakazka";
import UdrzbaCenik from "./udrzba/UdrzbaCenik";
import UdrzbaUcetnictvi from "./udrzba/UdrzbaUcetnictvi";
import UdrzbaKalendar from "./udrzba/UdrzbaKalendar";

export default function UdrzbaPage({ onLogout, onBackToModules }) {
  const [section, setSection] = useState("dashboard");
  const [calendarJumpToken, setCalendarJumpToken] = useState(0);

  const setSectionTraced = React.useCallback((next) => {
    try {
      console.groupCollapsed("🧭 UDRZBA setSection");
      console.log("from:", section);
      console.log("to:", next);
      console.trace("UDRZBA setSection trace");
      console.groupEnd();
    } catch {}
    setSection(next);
      if (next === "zakazky") {
        setCalendarJumpToken((x) => x + 1);
      }
  }, [section]);

  return (
    <UdrzbaLayout
      section={section}
      setSection={setSectionTraced}
      onLogout={onLogout}
      onBackToModules={onBackToModules}
    >
      {section === "dashboard" && <UdrzbaDashboard />}
      {section === "zakazky" && <UdrzbaZakazky calendarJumpToken={calendarJumpToken} />}
      {section === "nova" && <UdrzbaNovaZakazka setSection={setSectionTraced} />}
      {section === "cenik" && <UdrzbaCenik />}
      {section === "kalendar" && <UdrzbaKalendar setSection={setSectionTraced} />}
      {section === "ucetnictvi" && <UdrzbaUcetnictvi />}
    </UdrzbaLayout>
  );
}
